import { Link } from 'gatsby';
import PropTypes from 'prop-types';
import React from 'react';
import {
  FaFacebook as FacebookIcon,
  FaTwitter as TwitterIcon,
} from 'react-icons/fa';
import { GoMarkGithub as GithubIcon } from 'react-icons/go';
import logo from '../logo.svg';
import presets, { colors } from '../utils/presets';
import { options, rhythm, scale } from '../utils/typography';

import SearchForm from './search-form';

const navItemStyles = {
  ...scale(-1 / 3),
  boxSizing: `border-box`,
  display: `inline-block`,
  color: `inherit`,
  textDecoration: `none`,
  textTransform: `uppercase`,
  letterSpacing: `0.03em`,
  lineHeight: `calc(${presets.headerHeight} - 6px)`,
  padding: `6px ${rhythm(1 / 2)} 0`,
  position: `relative`,
  top: 0,
  transition: `color .15s ease-out`,
  '&:hover': {
    opacity: 0.8,
  },
};
const NavItem = ({ linkTo, children }) => (
  <li
    css={{
      display: `inline-block`,
      margin: 0,
    }}
  >
    <Link to={linkTo} css={navItemStyles}>
      {children}
    </Link>
  </li>
);

NavItem.propTypes = {
  linkTo: PropTypes.string.isRequired,
  children: PropTypes.string.isRequired,
};

const Navigation = () => {
  const styles = {};
  const socialIconsStyles = {
    color: colors.zoomdataGreen,
  };
  const gutters = {};

  return (
    <div
      role="navigation"
      css={{
        backgroundColor: `#ffffff`,
        borderBottom: `1px solid ${colors.ui.bright}`,
        height: presets.headerHeight,
        zIndex: `2`,
        left: 0,
        right: 0,
        [presets.Tablet]: { position: `fixed` },
        ...styles,
      }}
    >
      <div
        css={{
          margin: `0 auto`,
          paddingLeft: rhythm(3 / 4),
          paddingRight: rhythm(3 / 4),
          ...gutters,
          fontFamily: options.headerFontFamily.join(`,`),
          display: `flex`,
          alignItems: `center`,
          width: `100%`,
          height: `100%`,
        }}
      >
        <Link
          to="/"
          css={{
            alignItems: `center`,
            color: `inherit`,
            display: `flex`,
            textDecoration: `none`,
            marginRight: rhythm(1 / 2),
            backfaceVisibility: `hidden`,
          }}
        >
          <img
            alt="Zoomdata Logo"
            src={logo}
            css={{ height: 60, width: `auto`, margin: 0 }}
          />
        </Link>
        <ul
          css={{
            display: `none`,
            [presets.Tablet]: {
              display: `flex`,
              margin: 0,
              padding: 0,
              listStyle: `none`,
              flexGrow: 1,
              overflowX: `auto`,
              maskImage: `linear-gradient(to right, transparent, white ${rhythm(
                1 / 8,
              )}, white 98%, transparent)`,
            },
          }}
        >
          <NavItem linkTo="/docs/">Docs</NavItem>
          <NavItem linkTo="/tutorials/">Tutorials</NavItem>
          <NavItem linkTo="/blog/">Blog</NavItem>
        </ul>
        <div css={{ display: `flex`, marginLeft: `auto` }}>
          <SearchForm key="SearchForm" styles={{ ...navItemStyles }} />
          <a
            href="https://github.com/zoomdata"
            title="GitHub"
            css={{ ...navItemStyles, ...socialIconsStyles }}
          >
            <GithubIcon style={{ verticalAlign: `text-top` }} />
          </a>
          <a
            href="https://www.facebook.com/Zoomdata"
            title="Facebook"
            css={{ ...navItemStyles, ...socialIconsStyles }}
          >
            <FacebookIcon style={{ verticalAlign: `text-top` }} />
          </a>
          <a
            href="https://twitter.com/zoomdata"
            title="@Zoomdata"
            css={{ ...navItemStyles, ...socialIconsStyles, paddingRight: 0 }}
          >
            <TwitterIcon style={{ verticalAlign: `text-top` }} />
          </a>
        </div>
      </div>
    </div>
  );
};

export default Navigation;
